import { companyDomainService } from "@/api/acendex/company";
import { apiUserInfo } from "@/api/acendex/user";
import { imageConfig } from "@/config/config";
import { useFetch } from "@/lib/fetch-tools";
import { useTranslation } from "react-i18next";

export function HeroSection() {
  const { t } = useTranslation();
  const requestCompanyDomain = companyDomainService.useFetch({
    isInit: true,
  });
  const { data } = useFetch(apiUserInfo);
  const userInfo = data?.data;

  return (
    <div data-v-4389a7cf="" data-v-f68eea21="" className="warp w-full">
      <div data-v-4389a7cf="" className="middle-content px-4 mx-auto h-full ">
        <div
          data-v-4389a7cf=""
          className="banner mx-auto h-full flex flex-col md:flex-row md:box-border  md:justify-between md:pl-[120px]"
        >
          <div
            data-v-4389a7cf=""
            className="pt-7 font-medium text-center md:text-left md:w-[450px] md:pt-[76px]"
          >
            <p
              data-v-4389a7cf=""
              className="mb-5 pt-0.5 text-center text-[20px] leading-tight font-medium md:hidden"
            >
              Ascend in Trading, Lead in Memes
            </p>
            <p
              data-v-4389a7cf=""
              className="hidden font-outfit text-[34px] font-medium leading-[72px] sm:mb-6 sm:text-nowrap"
            >
              {" "}
              Ascend in Trading, Lead in Memes{" "}
            </p>
            <div
              data-v-4389a7cf=""
              className="mb-8 flex justify-center md:justify-start md:mb-0 md:gap-x-1.5 items-center gap-4"
            >
              <img
                className="h-10"
                src={
                  imageConfig.baseImageUrl +
                  requestCompanyDomain.data.value?.companyLogoName
                }
                alt={requestCompanyDomain.data.value?.companyName}
              />
            </div>
            {/* <!-- --> */}
            <p
              data-v-4389a7cf=""
              className="hidden font-outfit text-[34px] font-medium leading-[48px] sm:mb-8 sm:mt-4 sm:text-nowrap sm:block"
            >
              {" "}
              Ascend in Trading, Lead in Memes{" "}
            </p>
            {userInfo?.id ? (
              <div
                data-v-4389a7cf=""
                className="flex justify-center gap-x-4 md:justify-start md:mt-[60px]"
              >
                <a
                  data-v-4389a7cf=""
                  href="/rechargelist"
                  className="a-button b-butt h-10 flex items-center justify-center md:h-[52px] min-w-[120px] md:min-w-[140px]"
                >
                  {t("acendex.充值")}
                </a>
                <a
                  data-v-4389a7cf=""
                  role="button"
                  className="a-button-ghost b-butt h-10 flex items-center justify-center md:h-[52px]  min-w-[120px] md:min-w-[140px]"
                  href="/trade/btc"
                >
                  {t("acendex.交易")}
                </a>
              </div>
            ) : (
              <div className="flex flex-col gap-4 mb-8">
                {requestCompanyDomain.data?.value?.appStatus === 2 ? (
                  <a
                    href="/login"
                    className="bg-purple-500 text-white rounded-full py-3 text-center font-medium"
                  >
                    {t("登錄")}
                  </a>
                ) : (
                  <a
                    href="/download"
                    className="bg-purple-500 text-white rounded-full py-3 text-center font-medium"
                  >
                    {t("下載")} {requestCompanyDomain.data.value?.companyName}{" "}
                    APP
                  </a>
                )}
                <a href="/register" className="">
                  <div data-v-8b47f758="" className="input-wrap bg-white">
                    <div data-v-8b47f758="" className="el-input">
                      <div className="el-input__wrapper">
                        <input className="el-input__inner" type="text" />
                      </div>
                      <button data-v-8b47f758="" className="">
                        {t("立即註冊")}
                      </button>
                    </div>
                  </div>
                </a>
              </div>
            )}
          </div>
          <div data-v-4389a7cf="" className="relative mt-8 md:mt-0">
            {/* <img
              data-v-4389a7cf=""
              src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/ban_r_t.webp"
              className="w-full max-h-[300px] object-contain md:hidden"
              alt="banner-bg-mobile"
            /> */}
            <img
              data-v-4389a7cf=""
              src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/ban_r_t.webp"
              className="hidden h-full w-[811px] md:block"
              width="811"
              height="520"
              alt="banner-bg"
            />
          </div>
        </div>
      </div>
      {/* <!-- --> */}
    </div>
  );
}
